export const CREATE_DEVICE_ASSOCIATION =
  '[devices] create an alert or alarm device association';
export const EDIT_DEVICE_ASSOCIATION =
  '[devices] edit an alert or alarm device association';
export const PROCESS_DEVICE_ASSOCIATION =
  '[devices] process an alert or alarm device association';
export const PROCESS_DELETE_DEVICE_ASSOCIATION =
  '[devices] process deleting an alert or alarm device association';
export const DELETE_DEVICE_ASSOCIATION =
  '[devices] delete an alert or alarm device association';
export const DEVICE_ERROR = '[devices] device error';
export const LOAD_DEVICE_ASSOCIATIONS = '[devices] load device associations';
export const PROCESS_DEVICE_ASSOCIATIONS =
  '[devices] process device associations';
export const INSERT_DEVICE_ASSOCIATIONS =
  '[devices] insert device associations';
export const REMOVE_DEVICE_ASSOCIATION = '[devices] remove device association';

export const editDeviceAssociation = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: EDIT_DEVICE_ASSOCIATION,
  payload,
  navigate,
  previous,
  formSteps,
});

export const createDeviceAssociation = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: CREATE_DEVICE_ASSOCIATION,
  payload,
  navigate,
  previous,
  formSteps,
});

export const deleteDeviceAssociation = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: DELETE_DEVICE_ASSOCIATION,
  payload,
  navigate,
  previous,
  formSteps,
});

export const deviceError = () => ({
  type: DEVICE_ERROR,
});

export const processDeviceAssociation = (
  payload,
  history,
  previous,
  formSteps
) => ({
  type: PROCESS_DEVICE_ASSOCIATION,
  payload,
  history,
  previous,
  formSteps,
});

export const processDeleteDeviceAssociation = (
  payload,
  history,
  previous,
  formSteps
) => ({
  type: PROCESS_DELETE_DEVICE_ASSOCIATION,
  payload,
  history,
  previous,
  formSteps,
});
export const loadDeviceAssociations = () => ({
  type: LOAD_DEVICE_ASSOCIATIONS,
});
export const processDeviceAssociations = (payload) => ({
  type: PROCESS_DEVICE_ASSOCIATIONS,
  payload,
});
export const insertDeviceAssociations = (payload) => ({
  type: INSERT_DEVICE_ASSOCIATIONS,
  payload,
});
export const removeDeviceAssociation = (payload) => ({
  type: REMOVE_DEVICE_ASSOCIATION,
  payload,
});
